import { render, staticRenderFns } from "./ReviewCard.vue?vue&type=template&id=3d77e888"
import script from "./ReviewCard.vue?vue&type=script&lang=js"
export * from "./ReviewCard.vue?vue&type=script&lang=js"
import style0 from "./ReviewCard.vue?vue&type=style&index=0&id=3d77e888&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports